module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ppp-differentpaths010htmlch02"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppdifferentpaths006#ppp-differentpaths006htmltoc"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("I pushed the speed limit all the way home, my fingers crossed that the cops wouldn’t be out to get a single woman in a rusting truck. My luck held, and four hours later I pulled into the driveway at home, gravel spitting under my tires. My collie, Queenie, raced around in circles, barking, while Lucy’s nine-year-old daughter Tess stood goggled-eyed as I jumped out of the barely-stopped truck. I jogged to the barn, where Lucy was swabbing Sleeping Beauty’s udder. Queenie followed me, panting noisily, and I laid my hand on her head while I waited for Lucy’s report.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Lucy stood and rested an elbow on the cow’s sizable haunch. “Carla’s out of the woods. She’s stable, but they’re keeping her in the ICU for observation. She got a good whack on the head they want to monitor.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I sagged into a squat, Queenie offering support to keep me from falling. With shame I thought of my earlier wishes to smack Miranda on "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("her")]), _vm._v(" head. “Am I allowed to visit her?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Don’t know. I suppose. I’m sure she’d be glad to see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I rubbed the sides of Queenie’s neck, her long fur warm and soft. She sniffed at my face, her eyes betraying her heightened anxiety as she felt my own.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It’s okay, girl,” I told her. “It sounds like it’s going to be okay.” I stood. “All right if I head over to the hospital, then? She’s at Grand View?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yup. Go ahead. Zach’s here to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I glanced up, only now seeing our teen-age assistant further down the row. He tilted his chin my way, but otherwise ignored me.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Give Carla my love, will you?” Lucy said. “Tell her I’m praying for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Will do.” I gave Queenie one last pat. “You know any more details about what happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Lucy leaned back down, giving the cow’s teats a last swipe with her cloth. “Just that someone surprised her. Came up from behind in the parking lot of the Roy-El Diner and took off with the truck, catching Carla’s shirt in the door. Luckily she wasn’t wearing her coveralls, since she’d taken them off for lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Why’d she have the truck? She doesn’t usually work on Sundays.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She was on call. Had to go out to the Moyers’, check one of their horses. Anyway, her shirt ripped off almost as soon as the guy took off—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She’s sure it was a guy? She know who?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She didn’t really see him, but her impression was a male. Tall, in a ball cap and jacket. He took off and she banged her head on the pavement. Knocked her out. Some folks pulling into the parking lot found her. Don’t know how long she was lying there. Couldn’t have been too long.” She pulled the milker down and slid the hoses onto Sleeping Beauty’s teats.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Thanks for calling and letting me know.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“No problem. I figured you’d want to come back, just in case…”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("We let that thought go, and I turned to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Nick?” Lucy asked. “How is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I looked back. “He’s fine.” An image of his face, furrowed with concern as I stuffed dirty clothes into my duffel bag, rose before me. Our afternoon delight had obviously been postponed. Not for too long, I hoped, but we didn’t have a date set yet for our next visit. It was his turn to come up to PA, and it was hard finding a time when his doctors and family were willing to let him travel so far away.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’ll give him a call when I get back to let him know how Carla’s doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Lucy nodded, already on to the next cow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Grand View Hospital was busy, but I had no trouble finding Carla’s room. I’d been afraid they wouldn’t let me in, not being actual family, but the nurse was friendly and helpful, glancing at my tattoo only briefly before telling me Carla’s room number.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The door eased open with a quiet whoosh, and I caught a glimpse of Carla before she knew I’d arrived. I swallowed a gasp and stared at my friend’s face, already black and blue. Her arm was wrapped in gauze, and her nose had swelled to twice its normal size. I took a deep breath and entered.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Stella!” Her eyes lit up and a smile spread across her puffy face.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I made my way toward her, stopping suddenly at the sight of another person in the room. A man.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He stood quickly, his eyes flicking toward me. Tall and thin, his brown eyes bored into mine as his hands grasped a magazine rolled into a tight cylinder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Carla waved an arm, strapped with tape and an IV, toward him. “Stella, this is Bryan. Bryan, Stella. Stella’s known me for…well, forever, I guess. At least all the time that matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Hello.” He rolled the magazine even tighter, and twisted it in his hands before shifting it to his left hand and holding out his right.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I nodded, studying his blue cotton shirt and combed-back hair as I shook his hand. Pointy cowboy boots poked out from under his jeans, and a shiny NASCAR belt buckle adorned his waist. Super. I hoped he didn’t want to talk about Dale Earnhardt, Jr., or any of those other guys, because I knew nothing about them. Didn’t have any interest in them, either, as far as that went.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Um…” He let go of my hand and cleared his throat. “I guess I’ll go to the cafeteria. Get something to eat. If that’s okay.” He looked anxiously at Carla.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Of course that’s okay. Take your time. I’ve got some catching up to do with Stella, here.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Okay. Great. I’ll be back. If you’re sure.” He stepped toward the door, hesitated, and held the magazine out to Carla.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("She smiled. “You take it. Read it while you’re eating.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("A smile flickered on his face, and he ducked his head briefly before exiting through the whooshing door.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Who,” I asked, “was "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("that")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Her smile grew. “Bryan. I told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yeah, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“My new boyfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“New boyfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Why do you sound so skeptical? Think I can’t get one?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Stop it. It’s just I hadn’t heard about him.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("She tried to sit up straighter and winced. I reached out, but she waved me away. “Push that green button.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I jabbed it with my thumb, and the head of the bed rose, putting her at a better angle for talking. “I told you he’s new. I haven’t had a chance to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You met him where? The OK Corral?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Ha, ha. Very funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, the cowboy boots, the belt buckle…”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yeah, yeah, make fun. I just so happened to meet him country line dancing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I stared at her. “"), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("What")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I assume you’ve heard of it? The "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Boot Scootin’ Boogie")]), _vm._v("? The "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Tennessee Twister?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Of course I’ve heard of it. I just didn’t know you—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Could do it? I might be a little rounder than you, but that doesn’t mean I’m incapable of some fancy footwork.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I know that. I didn’t mean—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Bryan asked me to dance about, oh, three weeks ago, at the VFW in Souderton. We hit it off, and he’s been hanging around ever since. He’s been fantastic today after…well, since I got mugged.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I stepped closer. “Speaking of that…”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yeah, it’s something, huh? You like my new face?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It’ll be back to normal in no time.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I studied the IV in her arm. “So why are you still here? In the ICU?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("She waggled her eyebrows. “Subdural hematoma.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Which means…”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’ve got a skull fracture. A vessel in my head tore, and they want to make sure the tear isn’t expanding, bleeding all over the place in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“They didn’t do surgery?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Don’t need to for this, apparently, unless it gets worse. It’s basically a concussion. I had an awful headache—but I’m on drugs now, so I’m okay—and they did a CT scan. Now they keep me here and watch me. I’m hooked up to monitors they’re keeping an eye on.” She pointed out the various wires attached to her body.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“For how long?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Till they’re sure the tear is healing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I grimaced.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yeah, I know, it sounds awful. But you know the worst part?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m not allowed to eat anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I laughed. For Carla this was the hardest doctor’s order possible. “Should I sneak you in some ice cream?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("She groaned. “Don’t tease me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I pulled a chair to the side of the bed and sat. “So tell me what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You haven’t heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Just the basics, from Lucy. She sends her greetings, by the way, and her prayers.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Good ol’ Lucy. Couldn’t have anybody better praying.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Anyway, you don’t know who it was?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("She laid her head back and looked at the ceiling. “Just that it was a guy. At least, I’m pretty sure. He wasn’t real small or anything, and it wasn’t a wimpy shove. But the clothes looked like a guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“And he came up from behind and stole your truck.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("A shadow crossed her face. “My poor baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“No sign of it yet, that you’ve heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("She tilted her head toward me. “Detective Willard was here about an hour ago. Took my fingerprints in case they find my truck and need to eliminate me from the evidence. They haven’t found it. I’m not real hopeful they will.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Carla’s truck was her life. Or her job, anyway. The Ford F250 was outfitted with a Port-a-Vet, which held all the tools of her trade. Many of the instruments belonged to her, personally, and not to the practice.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You didn’t see the guy’s face?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You mean as I was caught in the door and slammed down onto the blacktop?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I winced. “Well, when you put it that way…”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("She lifted a hand. “The tiny glimpse I had was after the door was shut. I didn’t see much of anything. If I saw any details, I forgot them. A ball cap is about it. And I don’t even know what team. I sure hope he wasn’t a Phillies fan, or I’ll lose all my trust in human nature.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Willard able to give you any hope?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Not really. They have nothing to go on. At least not yet. By the time my truck got into the system as a stolen vehicle the guy was long gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Her eyelids suddenly drooped, closing for a long moment before opening again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I pushed the chair back and stood up. “I’ll let you get some rest. I just wanted to come by and make sure you were okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It’s these darn nurses.” Her voice was quiet, and a bit slurred. “They won’t let me sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“That concussion.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yeah, I know. And heaven forbid you let those vitals go without checking for more than two minutes.” She closed her eyes again, and seemed to sink further into the pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I reached out, then let my hand fall back to my side. “I’ll be back.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But she was already out.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b8aa9f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-differentpaths010.vue
// module id = 81
// module chunks = 0